import React, {useState, Fragment, useCallback, Suspense, useEffect} from 'react';
import { useForm, Controller  } from 'react-hook-form';
import { Card, CardBody, CardHeader, Form, FormGroup, Input,Button, TabPane, Row, Nav, NavItem, Col, NavLink, Label } from 'reactstrap';
import { Btn, H4 } from '../../../../../AbstractElements';
import Loader from '../../../../../Layout/Loader'
import DataTable from 'react-data-table-component';
// import { medicalreporttabledata, tableColumns } from '../../../../../Data/MedicalReport';
import { useLocation, useNavigate } from 'react-router';
import classnames from 'classnames';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { CreateMedicalReport, DeleteMedicalReport, MedicalreportList, MedicalReportTypeList } from '../../../../../apiController';
import {Navigator} from '../../../../../Data/Table/Defaultdata'
import { Modal, ModalHeader, ModalBody, } from 'reactstrap';

export const ImageModal = ({ isOpen, toggle, imageSrc }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Image Preview</ModalHeader>
      <ModalBody>
        <div className="text-center">
          <img src={imageSrc} alt="Preview" style={{ width: '100%', height: 'auto' }} />
        </div>
        <div className="text-center mt-3">
          <a href={imageSrc} download="document.jpg">
            <Button color="primary">Download</Button>
          </a>
        </div>
      </ModalBody>
    </Modal>
  );
};

const MedicalReport = ({ permission }) =>{

  const navigate = useNavigate()
  const [formdata, setFormdata] = useState({});
  const [reportType, setReportType] = useState([]);
  const [reportList, setReportList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [filePreview, setFilePreview] = useState(null);
    const [modal, setModal] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const toggleModal = (imageSrc) => {
    setCurrentImage(imageSrc);
    setModal(!modal);
  };

  const onFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const base64 = await fileToBase64(file);
      setFilePreview(base64);
    }
  };

  const location = useLocation()

  const {data} = location.state || {};

  const medicalreporttabledata = reportList.map((list, ind)=> (
    {
        ind: ind+1,
        id: list.id,
        filetype: list.category_name ,
        // image: list.document,
        image: list.document?(<span onClick={() => toggleModal(list.document)}><img src={list.document} alt="Document" style={{ width: '100px', height: 'auto' }} /></span>): '-',
        url: list.medical_document? list.medical_document : '-',
        status:"saved",

    }))

const tableColumns = [
    {
        name: '#',
        selector: row => row['ind'],
        sortable: true,
        center: true,
    },
    {
        name: 'File Type',
        selector: row => row['filetype'],
        sortable: true,
        center: true,
    },
    {
        name: 'Image',
        selector: row => row['image'],
        sortable: true,
        center: true,
    },
    {
      name: 'URL',
      selector: row => row['url'],
      sortable: true,
      center: true,
  },
    {
      name: 'Status',
      selector: row => `${row.status}`,
      sortable: true,
      center: true,
  },
];

  const fetchMedicalReportType = async () => {
    const response = await MedicalReportTypeList();
    if (response.status === true) {
      setReportType(response.data);
    }
  };

  useEffect(()=>{
    fetchMedicalReportType()
  },[])

  const {
    register,
    handleSubmit,
    control, 
    setValue,
    formState: { errors },
    reset
  } = useForm();

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  

  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

    // const [data, setData] = useState(medicalreporttabledata);

  const [currentActiveTab, setCurrentActiveTab] = useState('All'); 


 


  const onSubmit = (form) => {
    const formData = new FormData();
    console.log(form)
    formData.append("category_id", currentActiveTab);
    formData.append("patient_id", data.id);

    const fileInput = document.getElementById("filetype");
    if (fileInput && fileInput.files.length > 0) {
      const file = fileInput.files[0];
      formData.append("document", file); 
    } else {
      formData.append("document", ""); 
    }

    if (form.url) {
      formData.append("medical_document", form.url);
    } else {
      const fileInput = document.getElementById("filetype");
      if (fileInput && fileInput.files.length > 0) {
        const file = fileInput.files[0];
        formData.append("medical_document", URL.createObjectURL(file));
      } else {
        formData.append("medical_document", "");
      }
    }

    
    if(currentActiveTab !== "All"){
      createMedicalReport(formData)
  } else{
    formData.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
    toast.error("Please choose a category", {
      position: toast.POSITION.TOP_CENTER,
    });
  }
  };

  const createMedicalReport = async (data) => {
    setIsSubmitting(true)
    try{
      const response = await CreateMedicalReport(data);
        if (response.status === true) {
          toast.success("Created Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        toast.error("An error occurred!", {
          position: toast.POSITION.TOP_CENTER,
        });
      } finally {
        fetchFilterdReport()
        setValue('filetype', null); 
        setValue('url', '')
        setFilePreview(null)
        setIsSubmitting(false)
      }
    
   }

  useEffect(()=>{
    // console.log(data)
    fetchFilterdReport()
  },[])
	// Toggle active state for Tab 
	const toggle = tab => { 
    console.log(tab.toString())
		if (currentActiveTab !== tab) 
      setCurrentActiveTab(tab);
    fetchFilterData(tab.toString()) 

    if (tab === ''){
      fetchFilterData()
    }
	} 


  const fetchFilterData = async (tab) => {
    const response = await MedicalreportList({"patient_id": data.id});
    if(response.status === true) {
      const filteredInventoryList = response.data.filter(item => item.category_id.toString() === tab.toString());
      // console.log(filteredInventoryList)
      setReportList(filteredInventoryList);
  }
  }

  const fetchFilterdReport = async () => {
    const response = await MedicalreportList({"patient_id": data.id});
    if (response.status === true) {
      const filteredInventoryList = response.data;
      // console.log(filteredInventoryList)
      setReportList(filteredInventoryList);
    }
  };




    const handleRowSelected = useCallback(state => {
      console.log(state)
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = async () => {
      const result = await SweetAlert.fire({
        title: 'Are you sure you want to delete?',
        cancelButtonText: 'No!',
        confirmButtonText: 'Yes!',
        reverseButtons: true,
        showCancelButton: true,
      });
    
      if (result.isConfirmed) {
        try {
          const selectedIds = selectedRows.map(row => row.id); 
          await Promise.all(selectedIds.map(id => DeleteMedicalReport(id)));
          setSelectedRows([]);
          toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
        } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
        }
        finally{
          fetchFilterdReport()
        }
      }
    };
  return (
    <Suspense fallback={<Loader/>}>
    <Card>
      <CardHeader className='card-no-border'>
        <div className='mt-5'>
        <Nav tabs fill pills> 

        <NavItem> 
					<NavLink 
						className={classnames({ 
							active: 
								currentActiveTab === '1'
						})} 
						onClick={() => { toggle('1'); }} 
					> 
						All
					</NavLink> 
				</NavItem> 
        {reportType.map((row,ind)=>
          <NavItem key={row.id}> 
					<NavLink 
						className={classnames({ 
							active: 
								currentActiveTab === row.id
						})} 
						onClick={() => { toggle(row.id); }} 
					> 
						{row.name} 
					</NavLink> 
				</NavItem> 
        )}
			</Nav>
        </div>
        {currentActiveTab && permission?.create_access && <Fragment>
            <Card>
            <Form className="form theme-form" onSubmit={handleSubmit(onSubmit)}>
        <CardBody>
          <Row>
            <Col>
              <FormGroup className="row">
                <Label className="col-sm-3 col-form-label">Upload File</Label>
                <Col sm="9">
                <Controller
                  name="filetype"
                  control={control}
                  render={({ field }) => (
              <>
                <Input
                  type="file"
                  id="filetype"
                  accept=".jpg,.jpeg,.png,.svg"
                  {...field}
                  onChange={(e) => {
                    field.onChange(e); 
                    onFileChange(e); 
                  }}
                  className={`form-control ${errors.filetype ? 'is-invalid' : ''}`}
                />
                {filePreview && (
                  <div className="mt-2">
                    <img src={filePreview} alt="Preview" style={{ maxWidth: '100px', height: 'auto' }} />
                  </div>
                )}
              </>
            )}
          />
                  <span className="text-danger">{errors.filetype && "File Type is required"}</span>
                </Col>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <Row>
                <Label className="col-sm-3 col-form-label">URL</Label>
                <Col sm="9">
                  <Controller
                    name="url"
                    control={control}
                    render={({ field }) => (
                      <Input
                        type="text"
                        {...field}
                        className={`form-control ${errors.url ? 'is-invalid' : ''}`}
                      />
                    )}
                  />
                  <span className="text-danger">{errors.url && "URL is required"}</span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Button className="primary" type="submit"  disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </CardBody>
      </Form>
            </Card>
        </Fragment>}
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={medicalreporttabledata}
                columns={tableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
    <ImageModal isOpen={modal} toggle={() => setModal(!modal)} imageSrc={currentImage} />
    </Suspense>
  );
}

export default MedicalReport